
import {isGoogleAnalyticsEnabled} from "./AppSettings";

// Sends a custom GA event.
const sendGAEvent = (category, action, label) => {
    if(isGoogleAnalyticsEnabled() && ("ga" in window)) {
        const tracker = window.ga.getAll()[0];
        if (tracker) {
            tracker.send(
                "event",
                category,
                action,
                label
                );
        }
    }
}

// Sends a GA page view event.
const sendGAPageView = (page) => {
    if(isGoogleAnalyticsEnabled() && ("ga" in window)) {
        const tracker = window.ga.getAll()[0];
        if (tracker) {
            tracker.send(
            "screenView",
            page
            );
        }
    }
}

// This will initialize GA if it is enabled in the configuration.
const initGoogleAnalyticsIfEnabled = () => {
    const TrackingID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

    if(isGoogleAnalyticsEnabled() && TrackingID !== undefined) {
        // Only initialize GA if it is enabled in the configuration
        const domHead = document.getElementsByTagName("head")[0];

        const gtmScriptTag = document.createElement("script");
        gtmScriptTag.type = "text/javascript";
        gtmScriptTag.async = true;
        gtmScriptTag.src = "https://www.googletagmanager.com/gtag/js?id=" + TrackingID;
        domHead.appendChild(gtmScriptTag);

        getDataLayer();

        function gtag(){
            let dataLayer = getDataLayer();
            dataLayer.push(arguments);
        }

        gtag('js', new Date());      
        gtag('config', TrackingID);
    }
};

/**
 * Initializes the data layer to an empty array if not present, otherwise returns the current data layer.
 *
 * @returns the current data layer
 */
const getDataLayer = () => {
    window.dataLayer = window.dataLayer || [];

    return window.dataLayer;
}

/**
 * Logs a custom event.
 *
 * @param eventName The name of the event.
 */
const logCustomEvent = (eventName) => {

    if( !isGoogleAnalyticsEnabled() ) {
        // Do nothing when Google Analytics is off.
        return;
    }

    let dataLayer = getDataLayer();
    dataLayer.push({ event: eventName });

};

export { sendGAEvent, sendGAPageView, initGoogleAnalyticsIfEnabled, logCustomEvent };
